import SearchParamsBase from "../../../Elements/SearchParamsBase";

export default class AddressSearchParams extends SearchParamsBase
{
	static saveType = 'AddressSearchParams';
	initialize()
	{
		this.AddressId="";
		this.Name="";
		this.Line1="";
		this.City="";
		this.State="";
		this.CountryId="";
		this.PostalCode="";
		this.IsActive="true"
	}

}